import {Operator} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator"
import {OperatorToolboxBase} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/operator-toolbox-base"
import {TilingCanvasToolboxItemBase} from "@app/textures/texture-editor/operator-stack/operators/abstract-base/tiling-canvas-toolbox-item-base"

export class OperatorToolboxItemBase<OperatorClass extends Operator> extends TilingCanvasToolboxItemBase<OperatorToolboxBase<OperatorClass>> {
    constructor(toolbox: OperatorToolboxBase<OperatorClass>) {
        super(toolbox)
    }
}
